import React from 'react';

const BannerSkeleton = () => {
  return (
    <div className="bg-primary-100 w-full h-[250px] lg:h-[800px] animate-pulse rounded-md"></div>
  );
};

export default BannerSkeleton;
